import { ApplicationInsights } from '@microsoft/applicationinsights-web';

import { env } from '../env';
import { AppComponent, TelemetryEvent } from '../constants';

const connectionString = env.REACT_APP_APPINSIGHTS_CONNECTION_STRING;

type TelemetryProperties = Record<string, string | number | boolean | null | undefined>;

const isTelemetryEnabled = Boolean(connectionString);

export const appInsights = new ApplicationInsights({
   config: {
      connectionString,
      enableAutoRouteTracking: true,
      autoTrackPageVisitTime: true,
   },
});

if (isTelemetryEnabled) {
   appInsights.loadAppInsights();
} else {
   console.warn('Application Insights connection string is not set. Telemetry will not be sent.');
}

export function trackCustomEvent(event: TelemetryEvent, properties?: TelemetryProperties): void {
   if (!isTelemetryEnabled) return;
   appInsights.trackEvent({ name: event, properties });
}

export function trackComponentAccess(component: AppComponent, properties?: TelemetryProperties): void {
   trackCustomEvent(TelemetryEvent.COMPONENT_ACCESSED, {
      component,
      ...properties,
   });
}

export function setAuthenticatedUser(email?: string): void {
   if (!isTelemetryEnabled) return;

   const normalizedEmail = email?.trim();
   if (normalizedEmail) {
      appInsights.setAuthenticatedUserContext(normalizedEmail, undefined, true);
      return;
   }

   appInsights.clearAuthenticatedUserContext();
}
